import { useQuery } from "@tanstack/react-query";
import getPhaseRules from "api/campaign/getPhaseRules";
import { phaseRulesWithCampaignId } from "queryKeys/phaseRulesKey";

export default function useGetPhaseRulesQuery(campaignId) {
  return useQuery({
    queryKey: phaseRulesWithCampaignId({ campaignId }),
    queryFn: getPhaseRules,
    enabled: !!campaignId,
  });
}
